export default __webpack_public_path__ + "static/media/lt.170086e9.svg";